/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Awake_Buzzard_LaughInputs */

const fr_true_awake_buzzard_laugh = /** @type {(inputs: True_Awake_Buzzard_LaughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateurs`)
};

/**

* @param {True_Awake_Buzzard_LaughInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const true_awake_buzzard_laugh = /** @type {((inputs?: True_Awake_Buzzard_LaughInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Awake_Buzzard_LaughInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_true_awake_buzzard_laugh(inputs)
});